app.PublicDistrictPage = (
    function () {
        var publicDistrictPage = {
            //Index Page
            Index: function () {
                app.SavedVacancies.Init();
                $(document).ready(function () {
                    app.page.components["PublicDistrictPageVacanciesGrid"][0].refreshGrid();
                });
            }
        };
        return publicDistrictPage;
    }()
);